import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { RecoilRoot } from 'recoil'

import App from '../App/App'
import Login from 'controllers/Session/Login'
import ForgotPassword from 'controllers/Session/ForgotPassword'
import ChangePassword from 'controllers/Session/ChangePassword'

const Main = () => {
	return (
		<Router>
			<Switch>
				<Route path='/login' exact>
					<Login />
				</Route>
				<Route path='/forgot-password' exact>
					<ForgotPassword />
				</Route>
				<Route path='/change-password' exact>
					<ChangePassword />
				</Route>
				<Route path='/'>
					<RecoilRoot>
						<App />
					</RecoilRoot>
				</Route>
			</Switch>
		</Router>
	)
}

export default Main
